//Style
import './navbar.scss';
import { AccountUpdated } from 'modules/account/account/AccountController';
import moment from 'moment';
import 'moment/locale/pt-br';
import { NavbarFeatures } from 'modules/navbar/NavbarFeatures';
const CLOSED_MKT_BANNER = 'blip-closed-mkt-banner';
export class NavbarController {
    static $inject = ['$scope', '$rootScope', '$state', '$cookies', 'TranslateService', 'AccountService2', 'DOCS_URI', 'NG_TRANSLATE_LANG_KEY', 'BlipService', 'AuthenticationService', 'SegmentService'];
    constructor($scope, $rootScope, $state, $cookies, TranslateService, AccountService2, DOCS_URI, NG_TRANSLATE_LANG_KEY, BlipService, AuthenticationService, SegmentService) {
        'ngInject';
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$cookies = $cookies;
        this.TranslateService = TranslateService;
        this.AccountService2 = AccountService2;
        this.DOCS_URI = DOCS_URI;
        this.NG_TRANSLATE_LANG_KEY = NG_TRANSLATE_LANG_KEY;
        this.BlipService = BlipService;
        this.AuthenticationService = AuthenticationService;
        this.SegmentService = SegmentService;
        this.iframeMarketingUrl = false;
        this.collapsed = true;
        this.closeBanner = false;
        this.isHeaderDefined = false;
        this.userAccount();
        // Store the unregister function returned by $on
        this.accountUpdatedUnregister = this.$rootScope.$on(AccountUpdated, this.userAccount.bind(this));
        // Clean up on scope destroy
        this.$scope.$on('$destroy', () => {
            if (this.accountUpdatedUnregister) {
                this.accountUpdatedUnregister();
            }
        });
    }
    async $onInit() {
        await this.checkFeatures();
        this.resourceMenus();
        this.isHeaderDefined = true;
        await this.BlipService.waitForInitialization();
        // if it is not inside a bot context, connect BlipService using email:
        if (!this.$state.current.name.includes('detail') && !(await this.BlipService.isConnected())) {
            await this.BlipService.connect(encodeURIComponent(this.AuthenticationService.email), this.AuthenticationService.token);
        }
        await this.getAccountType();
    }
    async menuOpen() {
        this.SegmentService.createTrack('usermenu-dropdown-opened');
    }
    async checkFeatures() {
        try {
            this.iframeMarketingUrl = await NavbarFeatures.isMarketingBannerEnabled();
        }
        catch (e) {
            console.error(e);
        }
    }
    get loading() {
        return this.$scope.isLoadingGlobal();
    }
    get menus() {
        return this.MENUS_AUTH;
    }
    get showMarketingBanner() {
        return (!this.$cookies.getObject(CLOSED_MKT_BANNER) &&
            this.iframeMarketingUrl !== 'undefined' &&
            this.iframeMarketingUrl !== false);
    }
    async getAccountType() {
        try {
            const plan = await this.AccountService2.getAccountPlan();
            if (plan && plan.name) {
                this.userAccountType = plan.name.toLowerCase() == 'partner' ? 'business' : plan.name.toLowerCase();
                this.useSpecialHeader = this.userAccountType == 'business' || this.userAccountType == 'enterprise';
            }
            else {
                this.useSpecialHeader = false;
            }
        }
        catch (err) {
            console.error('Error trying to get account type: ', err);
            this.useSpecialHeader = false;
        }
    }
    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        const expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }
    getCookie(name) {
        const value = '; ' + document.cookie;
        const parts = value.split('; ' + name + '=');
        if (parts.length == 2) {
            return parts
                .pop()
                .split(';')
                .shift();
        }
    }
    translate(lang) {
        this.TranslateService.setCurrentLanguage(lang);
        this.setCookie(this.NG_TRANSLATE_LANG_KEY, lang, 365);
        const userLanguage = lang === 'pt' ? 'pt-BR' : lang;
        moment.locale(userLanguage);
        this.$state.reload();
    }
    async userAccount() {
        this.user = await this.AccountService2.me();
    }
    resourceMenus() {
        const chatbots = 'navbar.chatbots';
        const docs = 'navbar.docs';
        const forum = 'navbar.forum';
        const blog = 'navbar.blog';
        const helpCenter = 'navbar.helpCenter';
        const login = 'navbar.login';
        const createAccount = 'navbar.createAccount';
        const marketplace = 'navbar.gotoMarketplace';
        this.MENUS_AUTH = [
            { title: chatbots, sref: 'auth.application.list', showOnMenu: true },
            { title: helpCenter, href: 'https://help.blip.ai', showOnMenu: true },
            { title: marketplace, sref: 'auth.marketplace.list({from: "Header"})', showOnMenu: true },
        ];
        this.MENUS_ANON = [
            { title: login, sref: 'anon.login' },
            { title: createAccount, sref: 'anon.register' },
            { title: docs, href: this.DOCS_URI },
            { title: forum, href: 'http://forum.blip.ai' },
            { title: blog, href: 'http://blog.blip.ai' },
        ];
    }
    toggle(collapse) {
        this.collapsed = collapse || !this.collapsed;
    }
    isDetail() {
        return this.$state.includes('auth.application.detail');
    }
    closeMarketingBanner() {
        const expiration = new Date();
        expiration.setDate(expiration.getDate() + 5);
        this.$cookies.putObject(CLOSED_MKT_BANNER, this.iframeMarketingUrl, {
            expires: expiration,
        });
        this.iframeMarketingUrl = false;
    }
}
NavbarController.$inject = ['$scope', '$rootScope', '$state', '$cookies', 'TranslateService', 'AccountService2', 'DOCS_URI', 'NG_TRANSLATE_LANG_KEY', 'BlipService', 'AuthenticationService', 'SegmentService'];
